import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams, useRouteLoaderData } from "react-router";
import { defaultName } from "../const";
import _ from "lodash";
import { CampaignLoaderData } from "../Loader/compaignLoader";
import { useCartContext } from "../context/cartContext";
import { AiOutlineShoppingCart } from "react-icons/ai";
import { ROOT_URL } from "../config";
import DOMPurify from "dompurify";

export function Heading() {
  const loaderData = useRouteLoaderData("company-root") as CampaignLoaderData | undefined;
  const campaign = loaderData?.campaign ?? null;

  const barRef = useRef<HTMLDivElement | null>(null);
  const [barHeight, setBarHeight] = useState(86);

  useEffect(() => {
    const updateHeight = () => {
      if (barRef.current) setBarHeight(barRef.current.offsetHeight);
    };

    updateHeight();
    window.addEventListener("resize", updateHeight);

    const ro = new ResizeObserver(updateHeight);
    if (barRef.current) ro.observe(barRef.current);

    return () => {
      window.removeEventListener("resize", updateHeight);
      ro.disconnect();
    };
  }, []);

  const CartButton = ({ counting }: { counting: number }) => {
    const navigate = useNavigate();
    const { company: companyParam } = useParams();
    const { cartCounting } = useCartContext();

    return (
      <button
        className="btn"
        onClick={() => navigate(`/${companyParam}/cart`)}
        style={{
          position: "relative",
          width: 64,
          height: 50,
          backgroundColor: "var(--bs-primary)",
          borderRadius: "15%",
          zIndex: 1,
          border: "none",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            position: "absolute",
            left: 0,
            top: 0,
            width: 20,
            height: 20,
            border: "1px solid var(--bs-primary)",
            borderRadius: "50%",
            backgroundColor: "white",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 12,
            fontWeight: "bold",
            color: "var(--bs-primary)",
          }}
        >
          {cartCounting ?? 0}
        </div>
        <AiOutlineShoppingCart color="white" style={{ width: 24, height: 24 }} />
      </button>
    );
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: 0,
        flexDirection: "column",
        gap: 8,
        width: "100%",
      }}
    >
      <div
        ref={barRef}
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          width: "100%",
          maxWidth: "100vw",
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          padding: "max(12px, env(safe-area-inset-top, 0px)) 12px 12px",
          flexWrap: "nowrap",
          gap: 12,
          backgroundColor: "white",
          zIndex: 1200,
          boxShadow: "0px 7px 7.68px rgba(0, 0, 0, 0.1)",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 12,
            flex: "1 1 auto",
            minWidth: 0,
            maxWidth: "100%",
          }}
        >
          <div style={{ display: "flex", minWidth: 0 }}>
            <img
              src="/assets/LogoSectionWhite.png"
              alt="Hoikong Logo"
              style={{
                display: "block",
                width: "100%",
                height: "auto",
                // maxWidth: "100%",
                maxHeight: 50,
                objectFit: "contain",
              }}
            />
          </div>

          {!_.isNil(campaign) && campaign.attributes.logo?.data?.attributes?.url && (
            <div style={{ display: "flex", minWidth: 0 }}>
              <img
                src={`${ROOT_URL}${campaign.attributes.logo.data.attributes.url}`}
                alt="Campaign Logo"
                style={{
                  display: "block",
                  width: "100%",
                  height: "auto",
                  // maxWidth: "100%",
                  maxHeight: 50,
                  objectFit: "contain",
                }}
              />
            </div>
          )}
        </div>

        {!_.isNil(campaign) && campaign.attributes.name && (
          <div style={{ marginLeft: "auto" }}>
            <CartButton counting={0} />
          </div>
        )}
      </div>

      {/* Spacer to prevent fixed bar covering heading/body */}
      <div style={{ width: "100%", height: barHeight }} />

      <div className="p-4" style={{ textAlign: "center" }}>
        <h1 className="text-primary" style={{ fontSize: 32, fontWeight: "bold", marginBottom: 0 }} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(campaign?.attributes.name || defaultName) }} />
        {/* <h1 className="text-primary" style={{ fontSize: 32, fontWeight: "bold", marginBottom: 0 }}>
          {campaign?.attributes.name || defaultName}
        </h1> */}
      </div>
    </div>
  );
}